export default __webpack_public_path__ + "static/media/VideoContentThumbnailTemplate.0aa1b5da.png";